import { useState } from 'react'

import imageToBase64 from 'helpers/imageToBase64'

import ApplyFormLabel from '../ApplyFormLabel'
import FileDropzone from 'components/FileDropzone'
import ApplyStepIcon from 'components/ApplyStepIcon'
import ApplyStepButtons from 'components/ApplyStepButtons'

import s from './ApplyFormImages.module.css'
import * as Sentry from '@sentry/nextjs'

//TODO: setup proptypes
function ApplyFormImages({ onSubmit, goBack, initialValues }) {
  const [errors, setErrors] = useState([])
  const [fieldValues, setFieldValues] = useState({
    portrait: initialValues.portrait || null,
    fullFigure: initialValues.fullFigure || null,
    headAndShoulders: initialValues.headAndShoulders || null,
    sideOn: initialValues.sideOn || null,
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    const newErrors = Object.keys(fieldValues).filter((f) => !fieldValues[f])
    if (newErrors.length) {
      setErrors(newErrors)
    } else {

      const submitValues = {...fieldValues}

      Sentry.addBreadcrumb({
        category: 'form',
        message: 'Images Submitted',
        level: 'debug',
        data: submitValues,
      })

      onSubmit(submitValues)
    }
  }

  const handleFileRemove = (e, target) => {
    e.preventDefault()
    setFieldValues((curState) => ({ ...curState, [target]: null }))
  }

  const handleFileSelect = (attr, acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const fields = { ...fieldValues }
      fields[attr] = {
        name: acceptedFiles[0].file.name,
        preview: acceptedFiles[0].preview,
        data: null,
        loading: true,
        meta: null,
      }
      setFieldValues(fields)
      imageToBase64(acceptedFiles[0].file, {
        maxHeight: 1000,
        maxWidth: 1000,
      }).then((resp) => {
        setFieldValues((curState) => {
          const curFields = { ...curState }
          curFields[attr].data = resp.base64
          curFields[attr].loading = false
          curFields[attr].meta = JSON.stringify(resp.meta)
          return { ...curFields }
        })
      })
    }
  }

  const renderFileField = (label, attr, placeholder) => (
    <div className={s.field} key={attr.attr}>
      <ApplyFormLabel errors={errors} attr={attr} label={label} />
      <div className={s.inputWrapper}>
        <div className={s.imageWrapper}>
          <img
            src={
              fieldValues[attr.attr]
                ? fieldValues[attr.attr].preview
                : placeholder
            }
            alt={label}
            className={s.image}
          />
          <div className={s.imagePlaceholder} />
        </div>
        <FileDropzone
          disabled={fieldValues[attr.attr] && fieldValues[attr.attr].loading}
          onDrop={(files) => handleFileSelect(attr.attr, files)}
          file={fieldValues[attr.attr]}
          className={s.fileInput}
          iconClassName={s.inputIcon}
          hidePreview
        />
      </div>
    </div>
  )

  return (
    <div className={s.container}>
      <form onSubmit={handleSubmit}>
        <h1 className={s.title}>Images</h1>
        <p className={s.text}>Please no nudity, makeup and baggy clothes</p>
        <div className={s.columns}>
          <div className={s.column}>
            {[
              {
                label: 'Portrait',
                attr: { attr: 'portrait', label: 'Portrait image' },
                image: '/img/apply/portrait.jpg',
              },
              {
                label: 'Full figure',
                attr: { attr: 'fullFigure', label: 'Full figure image' },
                image: '/img/apply/full-figure.jpg',
              },
            ].map((field) =>
              renderFileField(field.label, field.attr, field.image),
            )}
          </div>
          <div className={s.column}>
            {[
              {
                label: 'Head & Shoulders',
                attr: {
                  attr: 'headAndShoulders',
                  label: 'Head & Shoulders image',
                },
                image: '/img/apply/head_shoulders.jpg',
              },
              {
                label: 'Side on',
                attr: { attr: 'sideOn', label: 'Side on image' },
                image: '/img/apply/side-on.jpg',
              },
            ].map((field) =>
              renderFileField(field.label, field.attr, field.image),
            )}
          </div>
        </div>
        <ApplyStepButtons back={goBack} />
      </form>
      <ApplyStepIcon step='4' />
    </div>
  )
}

export default ApplyFormImages
